import CamcFundDividend from "./fund-dividend";
import { AMCMessageUtil } from "_fil_local_addon/camc-cms-base/index";
import { FUND_API_SOURCES } from "_fil_local_addon/camc-cms-base/amc_fund_api.constant";
import { UrlTool } from "_fil_local_addon/camc-cms-base/index";

class WebsiteCamcFundDividend extends CamcFundDividend {
    constructor(fundCode, dividendWrapper, reportDateFilter) {
        super(fundCode, dividendWrapper, reportDateFilter);

        this.hostname = $("meta[name=data-api-origin]").attr("content");
        this.$fundDividendWrapper = $(`${dividendWrapper}`);
        this.$dividendTableWrapper = $(".fund-dividend-table-wrapper");
        this.$dividendTable = this.$dividendTableWrapper.find(".dividend-table");
        this.$dividendTableTb = this.$dividendTable.find("tbody");
        this.$dividendFilterSelect = $(".fund-dividend-filter-select");
        this.$dividendDownloadButton = $(".fund-dividend-download");
        this.bindEvents();
    }

    errorHandler() {
        showApiMessageing(this.$fundDividendWrapper);
    }

    bindEvents() {
        this.$dividendDownloadButton.on("click", (event) => {
            let url = `${this.hostname}${FUND_API_SOURCES.DIVIDEND_DOWNLOAD_SOURCE}${this.fundCode}`;
            let year = Number.parseInt(this.$dividendFilterSelect.val());
            if (!isNaN(year)) {
                url = UrlTool.addParam(url, "payDateYearFilter", year);
            }
            url = UrlTool.addParam(url, "reportDateFilter", reportDateFilter);
            window.location.href = url;
        });

        this.$dividendFilterSelect.on("change", (event) => {
            if (this.fundDividendList) {
                this.updateDividendTable(this.fundDividendList, event.currentTarget.value);
            }
        });
    }
    setMessage($fundDividendWrapper, message) {
        AMCMessageUtil.displayMessage($fundDividendWrapper, message);
    }

    updateDividendTable(fundDividendList, year) {
        fundDividendList = this.getFundDividendListByYear(fundDividendList, year);
        this.$dividendTableTb.empty();
        if (fundDividendList && fundDividendList.length > 0) {
            this.$dividendDownloadButton.removeAttr("disabled");
            fundDividendList.forEach((item) => {
                $(this.updateTableItem(item)).appendTo(this.$dividendTableTb);
            });
        } else {
            this.setMessage(this.$dividendTableTb, this.emptyMessageByRegion);
            this.$dividendDownloadButton.attr("disabled", true);
        }
    }

    updateTableItem(result) {
        let item = `
            <tr role="row" class=" fil-table-row--expanded " aria-label="Row">
                <td role="cell" class=" text-left " data-heading="红利发放日"
                    aria-label="Column">
                    <div class="fil-table-row-selector">
                        <div>
                            <div class="fil-table--cell-title">${result.payDate}</div>
                        </div>
                    </div>
                </td>
                <td role="cell" class=" text-left fil-table-row--column fil-table-row--border" data-heading="每单位分红(元)"
                    aria-label="Column">
                    <div class="fil-table-row-selector">
                        <div>
                            <span>${result.dividendAmount}</span>
                        </div>
                    </div>
                </td>
                <td role="cell" class=" text-center fil-table-row--column " data-heading="权益登记日"
                    aria-label="Column">
                    <div class="fil-table-row-selector">
                        <div>
                            <span>${result.recordDate}</span>
                        </div>
                    </div>
                </td>
            </tr>
        `;
        return item;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    if (window.fundCode) {
        reportDateFilter = window.reportDateFilter;
        let websiteCamcFundDividend = new WebsiteCamcFundDividend(
            window.fundCode,
            ".fund-dividend-wrapper",
            reportDateFilter,
        );
        websiteCamcFundDividend.render();
    }
});
